import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import BgImg1 from "../../../images/case-studies/mdrouz/audience.png";
import Img1 from "../../../images/case-studies/mdrouz/aud_mob.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Audiencecase = () => {
    return (
        <div className="audience_case" style={{ backgroundImage: `url(${BgImg1})` }}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="offset-xl-8 offset-lg-8 my-md-auto my-xl-0 my-xxl-0">
                        <div className="aud_head">
                            <h2>Target <span>Audience</span></h2>
                            <p>Mdrouz caters specifically to individuals in the GCC region seeking to purchase clothing articles like burqas and abayas. The app is designed to resonate with the cultural preferences and shopping habits of this target audience, offering a tailored and engaging experience.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={6}>
                        <div className="aud_img d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none">
                        <LazyLoadImage
                                    src={Img1}
                                    effect="blur" alt="TekRevol" className="img-fluid"
                                />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Audiencecase